/**
 * @description Store constants.
 * @type {{
 *  USER: string,
 *  CURRENT_LANGUAGE: string,
 *  DEFAULT_HOME_REPORT_VIEW: string,
 *  NAV_LINKS_LAST_VISITED: string,
 *  FILTER_STATES_HISTORY: string,
 *  TUTORIAL_TIPS: string,
 *  CONFIGURATION: string,
 * }}
 */
export const WESOG_STORE_PARAMS = {
    USER: 'user',
    CURRENT_LANGUAGE: 'currentLanguage',
    DEFAULT_HOME_REPORT_VIEW: 'defaultHomeReportView',
    NAV_LINKS_LAST_VISITED: 'navLinksLastVisited',
    FILTER_STATES_HISTORY: 'filterStatesHistory',
    TUTORIAL_TIPS: 'tutorialTips',
    CONFIGURATION: 'configuration',
};

/**
 * @description Session store constants.
 * @type {{
 *  USER: string,
 *  CURRENT_SELECTED_IMAGE: string,
 *  CURRENT_QUERY: string,
 *  LAST_REPORT_SELECTED: string,
 *  REDIRECT_HOME_REPORT_VIEW: string,
 *  CAPTCHA: string,
 * }}
 */
export const WESOG_SESSION_STORE_PARAMS = {
    USER: 'user',
    CURRENT_SELECTED_IMAGE: 'currentSelectedImage',
    CURRENT_QUERY: 'currentQuery',
    LAST_REPORT_SELECTED: 'lastReportSelected',
    REDIRECT_HOME_REPORT_VIEW: 'redirectHomeReportView',
    CAPTCHA: 'captcha',
};

/**
 * @description Store constants.
 * @type {{
 *   ID: string,
 *   ACTIVATED_FACES: string,
 *   DEACTIVATED_FACES: string,
 *   ACTIVATED_FILTERS: string,
 *   ACTIVATED_VIDEO_FILTERS: string,
 *   ORDER_BY_VALUE: string,
 *   PAGE_VALUE: string,
 *   PAGE_REPORT_VALUE: string,
 *   LAST_ELEMENT_SELECTED_ID: string,
 *   TOTAL_IMGS: string,
 *   TOTAL_REPORTS: string,
 *   REPORT_DETAILS_TITLE: string,
 *   SELECTED_TAB: string,
 * }}
 */
export const STORE_SEARCHER_FILTERS = {
    ID: 'id',
    ACTIVATED_FACES: 'activatedFaces',
    DEACTIVATED_FACES: 'deactivatedFaces',
    ACTIVATED_FILTERS: 'activatedFilters',
    ACTIVATED_VIDEO_FILTERS: 'activatedVideoFilters',
    ORDER_BY_VALUE: 'orderByValue',
    PAGE_VALUE: 'pageValue',
    PAGE_REPORT_VALUE: 'pageReportValue',
    LAST_ELEMENT_SELECTED_ID: 'lastElementSelected',
    TOTAL_IMGS: 'totalImgs',
    TOTAL_REPORTS: 'totalReports',
    REPORT_DETAILS_TITLE: 'reportDetailsTitle',
    SELECTED_TAB: 'selectedTab',
};

/**
 * @description Tutorial tip messages.
 * @type {{
 *   SEARCH_INPUT: string,
 *   AI_SWITCHER: string,
 *   IMAGE_SEARCHER: string,
 *   DEFAULT_REPORT: string,
 *   WIDGETS: string,
 *   CHARACTERS: string,
 *   INSTALLED_EXTENSION: string,
 * }}
 */
export const TUTORIAL_TIP_MESSAGES_TYPES = {
    SEARCH_INPUT: 'searchInput',
    AI_SWITCHER: 'aiSwitcher',
    IMAGE_SEARCHER: 'imageSearcher',
    DEFAULT_REPORT: 'defaultReport',
    WIDGETS: 'widgets',
    CHARACTERS: 'characters',
    INSTALLED_EXTENSION: 'installedExtension',
};

/**
 * @description Store configuration params.
 * @type {{
 *   PER_PAGE: string,
 *   OPEN_LINKS_IN_NEW_TAB: string,
 *   ZOOM: string,
 *   DARK_MODE: string,
 *   PAGINATION: string,
 *   DESCRIPTION_ACTIVE: string,
 * }}
 */
export const WESOG_STORE_CONFIGURATION_PARAMS = {
    PER_PAGE: 'perPage',
    OPEN_LINKS_IN_NEW_TAB: 'openLinksInNewTab',
    ZOOM: 'zoom',
    DARK_MODE: 'darkMode',
    PAGINATION: 'pagination',
    DESCRIPTION_ACTIVE: 'descriptionActive',
};

/**
 * @description Captcha store params.
 * @type {{
 *  EXPIRED_IN: string,
 *  FIRST_LOAD: string,
 * }}
 */
export const CAPTCHA_STORE_PARAMS = {
    EXPIRED_IN: 'expiredIn',
    FIRST_LOAD: 'firstLoad',
};
